import styled from 'styled-components';

export const PopoverContentWrapper = styled.div`
  max-width: 250px;
  text-align: center;
  color: ${({ theme }) => theme.colors.white};
`;
